"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importStar(require("styled-components"));

var Icon_1 = require("../../Icon/Icon");

exports.ValidationIconWrapper = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 2px;\n    right: 0;\n    width: 20px;\n    margin: 9px;\n"], ["\n    position: absolute;\n    bottom: 2px;\n    right: 0;\n    width: 20px;\n    margin: 9px;\n"])));
var iconNamesEnum;

(function (iconNamesEnum) {
  iconNamesEnum["valid"] = "check-circle";
  iconNamesEnum["notValid"] = "close-circle";
})(iconNamesEnum || (iconNamesEnum = {}));

var ValidationIcon = function ValidationIcon(_a) {
  var isValid = _a.isValid,
      theme = _a.theme;
  var color = isValid ? theme.colors.system.success : theme.colors.system.error;
  var name = isValid ? iconNamesEnum.valid : iconNamesEnum.notValid;
  return react_1.default.createElement(Icon_1.Icon, {
    name: name,
    size: Icon_1.IconSizeEnum.small,
    color: color
  });
};

exports.default = styled_components_1.withTheme(ValidationIcon);
var templateObject_1;